import PropTypes from 'prop-types'
import DOMPurify from 'isomorphic-dompurify'
import Translation from '#src/common/components/translation/'
import {
  IngredientsHeading,
  IngredientsText,
  IngredientsWrapper
} from './styles'
import { useEffect, useState } from 'react'

const Ingredients = ({
  ingredients,
  className,
  includeHeading,
  productName,
  explicitTitle
}) => {
  const [cleanMarkup, setCleanMarkup] = useState('')
  useEffect(() => {
    setCleanMarkup(DOMPurify.sanitize(ingredients))
  }, [ingredients])

  return ingredients ? (
    <IngredientsWrapper
      data-testid='ingredients-container'
      className={className}
    >
      {includeHeading ? (
        <IngredientsHeading level='h2' styleOverride='headingXs'>
          <Translation
            id='product.ingredients.heading'
            tokens={{ product: explicitTitle ? productName : undefined }}
          />
        </IngredientsHeading>
      ) : null}
      <Translation id='product.ingredients.subheading' />
      <IngredientsText
        dangerouslySetInnerHTML={{
          __html: cleanMarkup
        }}
      />
    </IngredientsWrapper>
  ) : null
}

Ingredients.propTypes = {
  className: PropTypes.string,
  includeHeading: PropTypes.bool,
  ingredients: PropTypes.string,
  productName: PropTypes.string,
  explicitTitle: PropTypes.bool
}

Ingredients.defaultProps = {
  className: '',
  includeHeading: true,
  ingredients: '',
  productName: '',
  explicitTitle: false
}

export default Ingredients
